//这是是二次封装的axios， 每次使用axios发送网络请求，都有一些重复的逻辑，
//在这里封装好，每次使用时就不用重复写了
import axios from "axios";
// 咱们当初再main.js里面已经将vant ui的组件全局化了，但request.js的扩展名是.js
// 而不是.vue; 所以天高皇帝远，皇上管不了它。所以在.js文件里想使用vant ui的话，用哪个组件，就得引入哪个组件
// 如果在.vue文件里，vant ui组件就在this身上，要用的话，直接this.$message就可以，不需要手动引入该组件

// 这种不是标签的，在哪里都要引入；如果是标签，全局安装后，才不需要引入。
import { Toast, Dialog } from "vant";
// 因为不是在.vue文件中，所以必须要引入router
// 否则如果是.vue文件，且在配置项里，那么直接在 vue上帝的原型链身上就能找到
// 这样写 this.$router身上就有
import router from "@/router"
import store from "@/store"
import { removeData } from '@/utils/auth'

// 创建axios的实例
const service = axios.create({
  //之前培训的时候老师购买的服务器的地址: 129.226.172.171; 现在暂时只能使用本地服务器来继续开发该项目，所以对应的服务器地址需要修改成localhost
  //AWS EC2云服务器的对外公网IP: 57.181.170.110
  //已经申请了域名proxyshop-joseph.com,所以EC2云服务器对应的公网IP可以直接删除了。
  // baseURL: "http://localhost:8012/proxyshop", //本地测试时正确的baseURL
  baseURL: "/proxyshop", // url = base url + request url
  withCredentials: true, // 解决跨域
  timeout: 5000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // 在发送请求之前做些事情
    if (store.state.user.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      //让每个请求都携带token
      //后端请求头携带的token的键名，不能是token_id,因为你加的‘_’, Nginx识别不了，是会出问题的
      //你可以额外配置Nginx, 让他识别下划线‘_’，但没那个必要了，直接不添加‘-’就可以了
      //顺便一说，请求头发送的这个token-Id的键名，是大小写不敏感的，其实相当于token-id
      config.headers['token-Id'] = store.state.user.token
    }
    return config
  },
  error => {
    // do something with request error
    console.log("会打印这里吗？");
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// 响应拦截器
// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  //这个括号里的response，是在发送网络请求之后，小神仙axios自动帮忙传过来的
  (response) => {
    //当我们使用axios发送网络请求时，小神仙axios返回响应数据(response)时，
    //会十分“好心眼儿”的帮你在数据最外层，再包装一层对象。然后，把真正的响应内容，
    //放在response.data里面。现在这部分代码的目的，就是让最后交出去的数据，是真正的响应内容，
    //而不是把整个response都交出去。
    //要是不在这里写这部分代码，那么，你将来就要经常写出像
    //this.value = res.data.data.value这样变态的代码。
    //但是如果做了如下处理，那么res.data就被包装成res交出去了，最后写的代码
    //就是this.value = res.data.value；就不是那么变态了.
    const res = response.data;

    // if the custom code is not 0, it is judged as an error.
    // 咱们前端给发过去的请求，只要到后端那里跑通了，后端都给你当作是“对”的。
    // 不会给你从后端就算成是错误。那么这个从后端返回的状态，前端如果不作处理
    // 就也会看成是正确的。譬如登录时，密码不正确，后端可能返回一个状态码(-1).
    // 但是，程序并不会自动的把它当成是错误。前端必须要手动处理一下。

    // 设定只有状态码是200时，才是正常，不是200，走下面处理错误的逻辑
    if (res.code !== 200) {
      //请求错误
      Toast.fail(res.message || res.msg || "リクエストエラー");
      if (res.code === -1) {
        // to re-login
        Dialog.confirm({
          // 您已经登出，请重新登录
          message: "ログアウトしました。再度ログインしてください",
          cancelButtonText: "キャンセル",
          confirmButtonText: "確認"
        }).then(() => {
          // 成功的逻辑，写在then方法里
          // 让路由跳转到register
          // 把之前前端缓存中保存的个人登录信息删除掉，如果不这么做，点击【确认】按钮之后前端画面会直接崩溃
          removeData();
          // 前端页面缓存删除之后，才会正常进入注册页面
          router.push("/register");
        }).catch(() => {
          // キャンセルした場合は何もしない
        });
      }
      //返回一个错误的promise，传递给调用封装了的axios的函数
      return Promise.reject(new Error(res.message || res.msg || "エラー"));
    } else {
    // 如果状态码是200， 才把res(response.data)交出去
      return res;
    }
  },
  (error) => {
    console.log("很可能是这里啊!!!");
    console.log(error.message);
    console.log(error.msg);
    console.log(error.message || error.msg || "错误");
    //错误
    Toast.fail(error.message || error.msg || "エラー");
    return Promise.reject(error);
  }
);

//把封装好的axios暴露出去。由于是export default, 所以是默认暴露
//就暴露它一个，没有其他的对象干扰。所以暴露出去的东西具体叫什么名字并没有那么重要，
//反正等别处引入的时候，可以随便再取一个名字
export default service;
